module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/result/thum01-b1ca8c6d106ca76090511875e067f06c.png";